// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import Routes from '../../utils/routes';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';

import FloatingBasketButton from './FloatingBasketButton';
import selectFloatingBasketButtonProps from './FloatingBasketButton.selector';

const StyledFloatingBasketButton = styled(FloatingBasketButton)`
  ${({ $isVisible }) =>
    !$isVisible
      ? css`
          opacity: 0;
          pointer-events: none;
        `
      : undefined}
`;

type FloatingBasketButtonContainerProps = {
  className?: string;
};

const FloatingBasketButtonContainer = (ownProps: FloatingBasketButtonContainerProps) => {
  const { history, location } = useRouter();
  const selectedProps = useSelector(selectFloatingBasketButtonProps);

  const onClick = useCallback(() => {
    history.push(RoutesRedirectionFactory.getBasketRouteConfig());
  }, [history]);

  const otherProps = useMemo(() => ({ onClick }), [onClick]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  const isVisible = useMemo(
    () =>
      !Routes.isKL(location.pathname, { exact: false }) &&
      !Routes.isMonopoly(location.pathname, { exact: false }) &&
      !Routes.isBoom(location.pathname, { exact: false }),
    [location],
  );

  return <StyledFloatingBasketButton {...enhancedProps} $isVisible={isVisible} />;
};

export default FloatingBasketButtonContainer;
